// extracted by mini-css-extract-plugin
export var paginationContainer = "_72-0";